import React, { useState } from "react";
import "./body.css";
import indexLogo from "../../assets/index_logo.png";
import analytics from "../../assets/AnalyticsLogoSingle.svg";
import agentMoptroLogo from "../../assets/Agent-MOPTro.png";
import paka from "../../assets/PAKA.png";
import pickingAnalytics from "../../assets/PickingAnalytics.png";
import voicePicking from "../../assets/VoiceBasedPicking.png";
import runTestApp from "../../assets/RunTest.png";
import Gdt from "../../assets/MOPTro.png";
import commchecklistLITE from "../../assets/pre-checklist-logo-square-dark.png";
import commchecklistSNAIL from "../../assets/post-checklist-logo-square-dark.png";
import dataCollection from "../../assets/data-collection-form-logo-square-dark.png";
import AppDownload from "../PopUp/AppDownload";
import { useNavigate } from "react-router-dom/dist";

const Body = () => {
   const naviagte = useNavigate();
   const [showPopup, setPopUp] = useState(false);
   const [selectedApp, setSelecetedApp] = useState("");
   const webApps = [
      {
         logo: indexLogo,
         name: "Index",
      },
      {
         logo: analytics,
         name: "Analytics",
      },
      // {
      //    logo: commchecklistLITE,
      //    name: "MOPTro LITE Commissioning Checklist",
      // },
      // {
      //    logo: commchecklistSNAIL,
      //    name: "MOPTro SNAIL Commissioning Checklist",
      // },
      // {
      //    logo: dataCollection,
      //    name: "W2H Data Collection Form",
      // },
      {
         logo: pickingAnalytics,
         name: "Analytics Picking",
      },
      {
         logo: paka,
         name: "Paka",
      },
      {
         logo: agentMoptroLogo,
         name: "Agent MOPTro",
      },
   ];

   const mobApps = [
      // {
      //    logo: Gdt,
      //    name: "Connect",
      // },
      {
         logo: Gdt,
         name: "Pick",
      },
      {
         logo: voicePicking,
         name: "Voice Based Pick",
      },
      {
         logo: runTestApp,
         name: "Run Test App",
      },
   ];

   const handleNavigate = (e) => {
      if (e === "Moptro Firmware") {
         window.open(
            "https://workdrive.zoho.com/folder/2douy02ccd25e08bc46269e9947e85d425708",
            "_blank",
            "noopener noreferrer",
         );
      } else if (e === "Voice Based Pick") {
         window.open(
            "https://workdrive.zoho.com/file/t4l5c953bfb5cc808407da39d7161c597f812",
            "_blank",
            "noopener noreferrer",
         );
      } else if (e === "Connect") {
         window.open(
            "https://workdrive.zoho.com/file/lpjd44eb6ca38eb90450da341415266091944",
            "_blank",
            "noopener noreferrer",
         );
      } else if (e === "Pick") {
         window.open(
            "https://workdrive.zoho.com/folder/9mw8x93bcc8070f2446bb877dd246ef1bff41",
            "_blank",
            "noopener noreferrer",
         );
      } else if (e === "Run Test App") {
         window.open(
            "https://workdrive.zoho.com/file/isfanae395addc6d646c49ca0efba18a0f798",
            "_blank",
            "noopener noreferrer",
         );
      } else {
         window.open(
            "https://workdrive.zoho.com/folder/lpjd46e40faec99e64bcea962bd433280e450",
            "_blank",
            "noopener noreferrer",
         );
      }
   };

   const handleClose = (e) => {
      setPopUp(false);
   };

   const handleNavigation = (e) => {
      switch (e) {
         case "Index":
            window.open("https://index.w2hconnect.com/app/", "_blank", "noopener noreferrer");
            break;
         case "Analytics":
            window.open("https://analytics.w2hconnect.com", "_blank", "noopener noreferrer");
            break;
         case "Agent MOPTro":
            window.open("https://agent-moptro-10033822351.catalystappsail.com/", "_blank", "noopener noreferrer");
            break;
         case "MOPTro Firmware":
            window.open(
               "https://workdrive.zoho.com/folder/2douy02ccd25e08bc46269e9947e85d425708",
               "_blank",
               "noopener noreferrer",
            );
            break;
         case "MOPTro Bluetooth Firmware":
            window.open(
               "https://workdrive.zoho.com/folder/2douycae49605c9414d6a8c01a98d93eb374b",
               "_blank",
               "noopener noreferrer",
            );
            break;
         case "Analytics Picking":
            window.open("https://analytics.zoho.com/open-view/1471251000002644177", "_blank", "noopener noreferrer");
            break;
         case "Paka":
            window.open("https://paka.w2hconnect.com/", "_blank", "noopener noreferrer");
            break;
         default:
            break;
      }
   };

   return (
      <div className="dash-body">
         {showPopup && <AppDownload isOPen={showPopup} close={handleClose} option={selectedApp} />}
         <div className="main-content">
            <div style={{ height: "100%" }} className="dash-box">
               <div className="access-info" role="note">
                  <span className="access-info-icon" aria-hidden="true">
                     i
                  </span>
                  <span>
                     A valid Greendzine business email and application access are required to use these applications.
                     PAKA App is accessible to all.
                  </span>
               </div>
               <section className="app-lists app-lists--web" aria-labelledby="web-apps-heading">
                  <div id="web-apps-heading" className="app-list-heading">
                     Web Applications
                  </div>
                  <hr style={{ opacity: "0.5", width: "80%" }} />
                  <div className="web-app">
                     {webApps.map((app, idx) => (
                        <div className="apps" onClick={() => handleNavigation(app.name)} key={idx}>
                           <img src={app.logo} alt="" />
                           <div className="app-name">{app.name}</div>
                        </div>
                     ))}
                  </div>
                  <div className="app-access-note section-access-note">
                     <span>
                        No access? Contact <a href="mailto:tejas.vinay@greendzine.in">IT Team Greendzine</a>
                     </span>
                  </div>
               </section>
               <section className="app-lists app-lists--mobile" aria-labelledby="mobile-apps-heading">
                  <div id="mobile-apps-heading" className="app-list-heading">
                     Mobile Applications
                  </div>
                  <hr style={{ opacity: "0.5", width: "80%" }} />
                  <div className="web-app">
                     {mobApps.map((app, idx) => (
                        <div className="apps" onClick={() => handleNavigate(app.name)} key={idx}>
                           <img
                              style={{ cursor: "pointer" }}
                              onClick={() => handleNavigate(app.name)}
                              src={app.logo}
                              alt=""
                           />
                           <div className="app-name" onClick={() => handleNavigate(app.name)}>
                              {app.name}
                           </div>
                        </div>
                     ))}
                  </div>
                  <div className="app-access-note section-access-note">
                     <span>Requires WorkDrive access with a valid Greendzine business email.</span>
                     <span>
                        No access? Contact <a href="mailto:tejas.vinay@greendzine.in">IT Team Greendzine</a>
                     </span>
                  </div>
               </section>
            </div>
         </div>
      </div>
   );
};

export default Body;
